module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQDesc1: 'Utilisez notre ',
        shadeFinder: 'Explorateur de teinte',
        colorIQDesc2: ' pour découvrir plus de correspondances en fonction de votre fond de teint actuel, ou rendez-vous dans un magasin Sephora et demandez un balayage du ton de la peau Color IQ.',
        captured: 'Capturé ',
        viewAll: 'Voir tout'
    };
    return resources[label];
};
